export default __webpack_public_path__ + "static/media/circleCloud10.8e5a895a.webp";